import { render, staticRenderFns } from "./ReturnSection.vue?vue&type=template&id=b5ee0766"
import script from "./ReturnSection.vue?vue&type=script&lang=js"
export * from "./ReturnSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports